import { render, staticRenderFns } from "./u-dialog-underline-tile.vue?vue&type=template&id=74c7658b&scoped=true&"
import script from "./u-dialog-underline-tile.vue?vue&type=script&lang=js&"
export * from "./u-dialog-underline-tile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c7658b",
  null
  
)

export default component.exports